import type { App } from 'vue'
import pagination from '@/components/pagination/index.vue'
import popup from '@/components/popup/index.vue'
import dictValue from '@/components/dict-value/index.vue'
import icon from '@/components/iconCollege/index.vue'
import editorCollege from '@/components/editorCollege/index.vue'
import footerBtns from '@/components/footer-btns/index.vue'
import appLink from '@/components/app-link/index.vue'
import colorPicker from '@/components/color-picker/index.vue'
import daterangePicker from '@/components/daterange-picker/index.vue'
import imageContain from '@/components/image-contain/index.vue'
import popoverInput from '@/components/popover-input/index.vue'
import overflowTooltip from '@/components/overflow-tooltip/index.vue'
import videoPlayer from '@/components/video-player/index.vue'

const modules = import.meta.glob('./**/*', { eager: true })

// 安装方法，执行某一类相同操作
function install(app: App<Element>) {
    Object.keys(modules).forEach((key) => {
        const name = key.replace(/(.*\/)*([^.]+).*/gi, '$2')
        const type = key.replace(/^\.\/([\w-]+).*/gi, '$1')
        const module: any = modules[key]
        if (module.default) {
            switch (type) {
                // 用于注册全局指令
                case 'directives':
                    app.directive(name, module.default)
                    break
                // 使用插件
                case 'plugins':
                    typeof module.default === 'function' && module.default(app)
                    break
            }
        }
    })
    app.component('pagination', pagination)
    app.component('popup', popup)
    app.component('dictValue', dictValue)
    app.component('icon', icon)
    app.component('editor', editorCollege)
    app.component('footerBtns', footerBtns)
    app.component('appLink', appLink)
    app.component('colorPicker', colorPicker)
    app.component('daterangePicker', daterangePicker)
    app.component('imageContain', imageContain)
    app.component('popoverInput', popoverInput)
    app.component('overflowTooltip', overflowTooltip)
    app.component('videoPlayer', videoPlayer)
}

export default {
    install
}
